//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
var BOUNCED_EMAIL_DATA_TYPE = {
  data: {
    by: 'Email',
    dataKey: 'bouncedEmail',
    url: '/backend/emailbouncelist',
    deleteItemUrl: '/backend/emailbouncelist?email={id}',
    idKeyProp: 'Email'
  },
  placeholders: {
    label: function label(data) {
      return data.Email;
    },
    type: function type() {
      return 'bounced email';
    },
    icon: function icon() {
      return 'email';
    }
  },
  columns: [{
    id: 'Email',
    children: 'Email',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      if (!data) return null;
      return React.createElement(Formatter.Text, {
        value: data.Email
      });
    },
    width: {
      xs: '25%'
    }
  }, {
    id: 'TimestampUTC',
    children: 'TimestampUTC',
    inMemorySort: false,
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      if (!data) return null;
      return React.createElement(Formatter.DateTime, {
        value: data.TimestampUTC,
        variant: "short",
        type: "datetime"
      });
    },
    width: {
      xs: '15%'
    }
  }, {
    id: 'Type',
    children: 'Type',
    inMemorySort: false,
    formatter: function formatter(_ref3) {
      var data = _ref3.data;
      if (!data) return null;
      return React.createElement(Formatter.Text, {
        value: data.Type
      });
    },
    width: {
      xs: '15%'
    }
  }, {
    id: 'Reason',
    children: 'Reason',
    inMemorySort: false,
    formatter: function formatter(_ref4) {
      var data = _ref4.data;
      if (!data) return null;
      return React.createElement(Formatter.Text, {
        value: data.Reason
      });
    }
  }]
};
export default BOUNCED_EMAIL_DATA_TYPE;